import React from 'react';

import EmployerPlanDetailsHSAContainer from './EmployerPlanDetailsHSA.container';
import EmployerPlanDetailsNotionalContainer from './EmployerPlanDetailsNotional.container';

interface Props {
  planId: string;
  isLoading: boolean;
  isHSA?: boolean;
}
const EmployerPlanDetailsContainer: React.FC<Props> = ({ isLoading, planId, isHSA }) => {
  if (isLoading) {
    return null;
  }
  if (isHSA) {
    return <EmployerPlanDetailsHSAContainer isLoading={isLoading} planId={planId} />;
  }
  return <EmployerPlanDetailsNotionalContainer isLoading={isLoading} planId={planId} />;
};

export default EmployerPlanDetailsContainer;
